/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function DatabaseIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="database"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M20.5 8A8.5 4.5 0 0 1 3.5 8A8.5 4.5 0 0 1 20.5 8" data-tinysvg-shape="arc" data-tinysvg-arc="12 8 8.5 4.5 0 360 0 ellipse" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M3.5 8L3.5 16" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.5 8L20.5 16" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.5 12A8.5 4.5 0 0 1 3.5 12" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 8.5 4.5 0 180 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20.5 16A8.5 4.5 0 0 1 3.5 16" data-tinysvg-shape="arc" data-tinysvg-arc="12 16 8.5 4.5 0 180 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
